import { useEffect, useRef } from 'react';

import { useAmpli } from '@/ampli';
import type { CompareAddressLookupFailedProperties } from '@/ampli/generated';
import type { CompareAddressCreateFailure } from '@/hooks/use-compare-create-area-preview';

const useCompareAddressCreateFailure = ({
  blogSlug,
  failure,
  placement,
}: {
  blogSlug?: string;
  failure: CompareAddressCreateFailure | null;
  placement: CompareAddressLookupFailedProperties['placement'];
}) => {
  const ampli = useAmpli();
  const reportedFailureRef = useRef(failure);

  useEffect(() => {
    if (failure == null) {
      reportedFailureRef.current = null;
      return;
    }

    if (reportedFailureRef.current === failure) {
      return;
    }

    reportedFailureRef.current = failure;
    ampli((client) =>
      client.compareAddressLookupFailed({
        placement,
        blog_slug: blogSlug,
        reason: 'lookup_error',
      }),
    );
  }, [ampli, blogSlug, failure, placement]);
};

export default useCompareAddressCreateFailure;
